namespace $ {
	$.$mol_build.start = () => {}
}
